import type firebase from "firebase/app";
import { initializeApp } from "firebase/app";
import { type Database, getDatabase } from "firebase/database";

const LOG_TAG = "🔥 firebaseInitialize";
const DEBUG = false;

let firebaseApp: firebase.FirebaseApp;
export function getFirebaseApp(): firebase.FirebaseApp {
  if (firebaseApp) {
    return firebaseApp;
  }
  const firebaseConfig = {
    apiKey: process.env.NEXT_PUBLIC_GOOGLE_API_KEY,
    authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.NEXT_PUBLIC_FIREBASE_DATABASE_URL,
    projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
    storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
    appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
    //messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
    //measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID,
  };
  try {
    firebaseApp = initializeApp(firebaseConfig);
    if (DEBUG) console.debug(LOG_TAG, "initialized");
  } catch (err) {
    console.error(LOG_TAG, "FAILED to initialize", err, {
      firebaseConfig,
    });
  }
  return firebaseApp;
}

let firebaseDatabase: Database;
export function getFirebaseDatabase() {
  if (firebaseDatabase) {
    return firebaseDatabase;
  }
  const firebaseApp = getFirebaseApp();
  try {
    firebaseDatabase = getDatabase(firebaseApp);
  } catch (err) {
    console.error(LOG_TAG, "Database FAILED to initialize", err);
  }
  return firebaseDatabase;
}
